<template>
<div class="action-flow-node action-flow-node-danger" style="height: 200px;">
	<div class="action-flow-title">Update Mote</div>
	<div class="action-flow-hint">Update user values in a single mote of data, immediately saving.</div>
	
	<ActionParamHint label="Mote" hint="Mote to update." param-class="param-tgt" />
	<ActionParamHint label="Data" hint="Field values to update in the mote. You can feed in objects to this input to use them in the message format." param-class="param-tgt" 
		param-input-type="textarea" param-input-label="Field values" @param-change="handleParamChange"
		:param-input-value="parameters.data"
	/>
	<ActionParamHint label="Updated" hint="The mote after updating." param-class="param-src" />
	
	<Handle type="target" id="tgt-mote" :position="Position.Left" style="top: 95px;" />
	<Handle type="target" id="tgt-data" :position="Position.Left" style="top: 135px;" />
	<Handle type="source" id="src-updated" :position="Position.Right" style="top: 175px;" />
</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	mote: '',
	data: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			mote: newNodeData.data?.mote || '',
			data: newNodeData.data?.data || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	let key = paramData.label.toLowerCase();
	if (!(key in parameters.value)) {
		console.error(`Unknown parameter label: ${paramData.label}`);
		return;
	}
	parameters.value[key] = paramData.value;
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>

